import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconMultiLanguageStyle0 = cosmosIconCss;

const CosmosIconMultiLanguage$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMultiLanguage extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '84561fb93d17bcb75214fc4110c4f16b36ff990c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3e51226a3541465481c9d335ccc777e688509073', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e70f9226d6d2dda51baf0991d8d794a43e76078c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 2h-12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H8a.5.5 0 0 0 .5-.5v-1h10v6H17a.5.5 0 0 0-.5.5v2.947a.5.5 0 0 0 .113.316l.828 1.016a.304.304 0 0 0 .559-.165V11h1.5a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5Zm-17 5h11.521a.482.482 0 0 1 .478.5v8.004a.478.478 0 0 1-.473.5H7.997l-3.486 3.51A.3.3 0 0 1 4 19.3v-3.296H2.5a.5.5 0 0 1-.501-.5V7.5a.5.5 0 0 1 .5-.5Zm5.502 6.499a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3.002ZM11.003 10a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 5 9h5.503a.5.5 0 0 1 .5.5v.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconMultiLanguageStyle0; }
}, [1, "cosmos-icon-multi-language", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-multi-language"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-multi-language":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMultiLanguage$1);
            }
            break;
    } });
}

const CosmosIconMultiLanguage = CosmosIconMultiLanguage$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMultiLanguage, defineCustomElement };
